import { ReactComponent as ManualSeeker1 } from "assets/icons/manual-seeker-1.svg";
import { ReactComponent as ManualSeeker2 } from "assets/icons/manual-seeker-2.svg";
import { ReactComponent as ManualSeeker3 } from "assets/icons/manual-seeker-3.svg";
import { ReactComponent as ManualProvider1 } from "assets/icons/manual-provider-1.svg";
import { ReactComponent as ManualProvider2 } from "assets/icons/manual-provider-2.svg";
import { ReactComponent as ManualProvider3 } from "assets/icons/manual-provider-3.svg";
import { ReactComponent as ManualProvider4 } from "assets/icons/manual-provider-4.svg";

export const dashboardConfig = {
  seeker: {
    summaryBlocks: [
      { key: "activeReservations", valueKey: "bookings" },
      { key: "newMessages", valueKey: "messages" },
      { key: "seeker.spacesToRate", valueKey: "notes" },
    
    ],
    steps: [
      { SvgIcon: ManualSeeker1, titleKey: "step1Title", textKey: "step1Text" },
      { SvgIcon: ManualSeeker2, titleKey: "step2Title", textKey: "step2Text" },
      { SvgIcon: ManualSeeker3, titleKey: "step3Title", textKey: "step3Text" },
    ],
    contactTextKey: "seeker.text",
  },
  provider: {
    summaryBlocks: [
      { key: "provider.activeSpaces", valueKey: "places" },
      { key: "provider.offlineSpaces", valueKey: "places_off" },
      { key: "activeReservations", valueKey: "bookings" },
      { key: "newMessages", valueKey: "messages" },
    ],
    steps: [
      {
        SvgIcon: ManualProvider1,
        titleKey: "step1Title",
        textKey: "step1Text",
      },
      {
        SvgIcon: ManualProvider2,
        titleKey: "step2Title",
        textKey: "step2Text",
      },
      {
        SvgIcon: ManualProvider3,
        titleKey: "step3Title",
        textKey: "step3Text",
      },
      {
        SvgIcon: ManualProvider4,
        titleKey: "step4Title",
        textKey: "step4Text",
      },
    ],
    contactTextKey: "provider.text",
  },
  master_seeker: {
    summaryBlocks: [
      { key: "activeReservations", valueKey: "bookings" },
      { key: "bookingStats.waiting", valueKey: "stats.pending" },
      { key: "bookingStats.confirmed", valueKey: "stats.approved"  },
      { key: "bookingStats.canceled", valueKey: "stats.rejected" },

      // { key: "seeker.spacesToRate", valueKey: "notes" },
    ],
    steps: [
      
    ],
    contactTextKey: "seeker.text",
  },
};
